import { AuthContext, useApi } from '@repo-level/core-front';
import useEventListener from '@repo-level/core-front/hooks/eventListener';
import { confirmationEmailPost } from 'api/auth';
import { ButtonCross } from 'components/buttons';
import { AddonsContext } from 'contexts/addons';
import { showTooltip } from 'helpers/tooltip';
import { translationFactory } from 'helpers/trans';
import { TooltipTypes } from 'modules/globalTooltip';
import { useCallback, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { ScEmailConfirmPopup } from './styled';

export const EmailConfirmPopup = () => {
  const { setEmailConfirmationPopupSeen, setEmailConfirmationPopupHeight } =
    useContext(AddonsContext);

  const { user } = useContext(AuthContext);

  const [requestsConfirmationEmail] = useApi(confirmationEmailPost);

  const { t } = useTranslation('common');

  const ref = useRef<HTMLDivElement>(null);

  const handleLinkClick = useCallback(async () => {
    if (!user) return;

    const { error } = await requestsConfirmationEmail(user.email).request;

    if (error) return;

    setEmailConfirmationPopupSeen();

    showTooltip({
      type: TooltipTypes.SUCCESS,
      translate: true,
      title: translationFactory('verifyEmailPopup.successTooltip'),
    });
  }, [requestsConfirmationEmail, setEmailConfirmationPopupSeen, user]);

  const handleCloseClick = useCallback(() => {
    setEmailConfirmationPopupSeen();
  }, [setEmailConfirmationPopupSeen]);

  useEventListener(
    'resize',
    () =>
      ref.current && setEmailConfirmationPopupHeight(ref.current?.clientHeight),
    undefined,
    true
  );

  return (
    <ScEmailConfirmPopup ref={ref}>
      <div className="text">
        {t('verifyEmailPopup.text')}
        <span className="link" onClick={handleLinkClick}>
          {t('verifyEmailPopup.linkText')}
        </span>
      </div>
      <ButtonCross onClick={handleCloseClick} right={16} small top={4} />
    </ScEmailConfirmPopup>
  );
};
